/**
 * Lithuanian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const lt: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Valdymo skydelis',
  'nav.funds': 'Fondai',
  'nav.investments': 'Investicijos',
  'nav.investees': 'Investicijų gavėjai',
  'nav.esg': 'ESG Apžvalga',
  'nav.compliance': 'Atitiktis',
  'nav.reports': 'Ataskaitos',
  'nav.settings': 'Nustatymai',
  'nav.users': 'Naudotojai',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Rodikliai',
  'nav.taxonomy': 'ES Taksonomija',
  'nav.filings': 'Pateikimai',
  'nav.calendar': 'Kalendorius',
  'nav.submit': 'Pateikti duomenis',
  'nav.submissions': 'Mano pateikimai',
  'nav.benchmarks': 'Lyginamieji rodikliai',
  'nav.messages': 'Žinutės',
  'nav.portfolio': 'Portfelis',
  'nav.performance': 'Fondų rezultatai',
  'nav.esgSummary': 'ESG Santrauka',
  'nav.pipeline': 'Konvejeris',
  'nav.dueDiligence': 'Išsamus patikrinimas',
  'nav.impact': 'Poveikio rodikliai',
  'nav.sdg': 'DVT Žemėlapis',
  'nav.audit': 'Audito pėdsakas',
  'nav.snapshots': 'Duomenų momentinės kopijos',
  'nav.knowledgeGraph': 'Žinių grafas',
  'nav.geographic': 'Geografinis',
  'nav.bi': 'BI Studija',
  'nav.ai': 'AI Asistentas',
  'nav.tasks': 'Užduotys',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Reguliacinis monitorius',

  // Common Actions
  'action.create': 'Sukurti',
  'action.edit': 'Redaguoti',
  'action.delete': 'Ištrinti',
  'action.save': 'Išsaugoti',
  'action.cancel': 'Atšaukti',
  'action.submit': 'Pateikti',
  'action.approve': 'Patvirtinti',
  'action.reject': 'Atmesti',
  'action.download': 'Atsisiųsti',
  'action.export': 'Eksportuoti',
  'action.import': 'Importuoti',
  'action.filter': 'Filtruoti',
  'action.search': 'Ieškoti',
  'action.refresh': 'Atnaujinti',
  'action.close': 'Uždaryti',
  'action.back': 'Atgal',
  'action.next': 'Kitas',
  'action.previous': 'Ankstesnis',
  'action.viewAll': 'Peržiūrėti viską',
  'action.viewDetails': 'Peržiūrėti detales',
  'action.generate': 'Generuoti',
  'action.signOut': 'Atsijungti',
  'action.addNew': 'Pridėti naują',
  'action.invite': 'Pakviesti',

  // Statuses
  'status.draft': 'Juodraštis',
  'status.submitted': 'Pateikta',
  'status.validated': 'Patvirtinta',
  'status.approved': 'Patvirtinta',
  'status.rejected': 'Atmesta',
  'status.pending': 'Laukiama',
  'status.inProgress': 'Vykdoma',
  'status.overdue': 'Vėluojama',
  'status.compliant': 'Atitinkama',
  'status.filed': 'Pateikta',
  'status.active': 'Aktyvu',
  'status.inactive': 'Neaktyvu',
  'status.closed': 'Uždaryta',
  'status.fundraising': 'Lėšų rinkimas',
  'status.investing': 'Investavimas',
  'status.harvesting': 'Derliaus nuėmimas',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Portfelio apžvalga',
  'dashboard.complianceStatus': 'Atitikties būsena',
  'dashboard.collectionProgress': 'Rinkimo progresas',
  'dashboard.activityFeed': 'Veikla',
  'dashboard.quickActions': 'Greiti veiksmai',
  'dashboard.investmentPipeline': 'Investicijų konvejeris',
  'dashboard.totalFunds': 'Iš viso fondų',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Aktyvios investicijos',
  'dashboard.totalInvestees': 'Investicijų gavėjai',
  'dashboard.recentActivity': 'Naujausia veikla',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Iš viso įsipareigota',
  'lp.capitalCalled': 'Pareikalauta kapitalo',
  'lp.distributed': 'Paskirstyta',
  'lp.netPosition': 'Grynoji pozicija',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Fondų rezultatai',
  'lp.esgSummary': 'ESG Santrauka',
  'lp.reportLibrary': 'Ataskaitų biblioteka',
  'lp.taxonomyAligned': 'Suderinta su taksonomija',
  'lp.paiCoverage': 'PAI Aprėptis',
  'lp.portfolioPerformance': 'LP Portfelio rezultatai',

  // Fund Labels
  'fund.name': 'Fondo pavadinimas',
  'fund.code': 'Fondo kodas',
  'fund.vintage': 'Įsteigimo metai',
  'fund.size': 'Fondo dydis',
  'fund.targetSize': 'Tikslinis dydis',
  'fund.currency': 'Valiuta',
  'fund.strategy': 'Strategija',
  'fund.status': 'Būsena',
  'fund.sfdrCategory': 'SFDR Kategorija',
  'fund.geographyFocus': 'Geografinis fokusas',
  'fund.sectorFocus': 'Sektoriaus fokusas',

  // Form Labels
  'form.name': 'Pavadinimas',
  'form.email': 'El. paštas',
  'form.country': 'Šalis',
  'form.amount': 'Suma',
  'form.currency': 'Valiuta',
  'form.date': 'Data',
  'form.description': 'Aprašymas',
  'form.notes': 'Pastabos',
  'form.type': 'Tipas',
  'form.period': 'Laikotarpis',
  'form.year': 'Metai',
  'form.required': 'Privalomas',
  'form.optional': 'Neprivalomas',

  // Table Headers
  'table.fund': 'Fondas',
  'table.commitment': 'Įsipareigojimas',
  'table.called': 'Pareikalauta',
  'table.distributed': 'Paskirstyta',
  'table.tvpi': 'TVPI',
  'table.status': 'Būsena',
  'table.regulation': 'Reguliavimas',
  'table.filingType': 'Pateikimo tipas',
  'table.reportingPeriod': 'Laikotarpis',
  'table.createdAt': 'Sukurta',
  'table.actions': 'Veiksmai',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'ES Taksonomija',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Duomenų užbaigtumas',
  'compliance.nextDeadline': 'Kitas terminas',

  // Reports
  'report.quarterly': 'Ketvirtinė ataskaita',
  'report.annual': 'Metinė ataskaita',
  'report.paiStatement': 'PAI Pareiškimas',
  'report.taxonomyReport': 'Taksonomijos ataskaita',
  'report.generatedAt': 'Sugeneruota',
  'report.version': 'Versija',

  // General
  'general.loading': 'Kraunama...',
  'general.noData': 'Nėra prieinamų duomenų',
  'general.error': 'Įvyko klaida',
  'general.retry': 'Bandyti dar kartą',
  'general.total': 'Iš viso',
  'general.page': 'Puslapis',
  'general.of': 'iš',
  'general.showing': 'Rodoma',
  'general.results': 'rezultatai',
  'general.language': 'Kalba',
  'general.english': 'Anglų',
  'general.french': 'Prancūzų',
};
